import { CONTROL_CONTEXTS, CONTROL_SLIDER_SIZES } from '../controls';

export const WORKSPACE_CONTROL_KINDS = {
  AUTOCOMPLETE: 'autocomplete',
  BUTTON: 'button',
  CATEGORY: 'category',
  NUMBER: 'number',
  SEARCH: 'search',
  SELECT: 'select',
  SLIDER: 'slider',
  TOGGLE: 'toggle',
};

export const WORKSPACE_PANEL_KINDS = {
  CHART: 'chart',
  CHART_TABLE: 'chartTable',
  EMPTY: 'empty',
  KPI_STRIP: 'kpiStrip',
  SINGLE: 'singlePanel',
  SPLIT: 'splitPanel',
  TABLE: 'table',
};

export const WORKSPACE_VISUALIZATION_KINDS = {
  BOXPLOT: 'boxplot',
  BRIDGE: 'bridge',
  GROUPED_BAR: 'groupedBar',
  HEATMAP: 'heatmap',
  KPI_STRIP: 'kpiStrip',
  QUADRANT: 'quadrant',
  ROLE_MIX: 'roleMix',
  SCATTER: 'scatter',
  STACKED_BAR: 'stackedBar',
  TABLE: 'table',
  TREEMAP: 'treemap',
  TREND_LINE: 'trendLine',
};

export const WORKSPACE_TABLE_COLUMN_KINDS = {
  CATEGORY: 'category',
  COMPANY: 'company',
  DATE: 'date',
  LINK: 'link',
  METRIC_VALUE: 'metricValue',
  MEDIAN_METRIC_VALUES: 'medianMetricValues',
  PERCENT: 'percent',
  RANK: 'rank',
  TICKER: 'ticker',
  TREND_DELTA: 'trendDelta',
  TITLE: 'title',
  GROUP: 'group',
  REGION: 'region',
  SUB_REGION: 'subRegion',
  COMPANY_MAPPING: 'companyMapping',
  LOCATION: 'location',
};

export const WORKSPACE_CONTROL_PRESETS = {
  artifactEventCategory: { id: 'artifactEventCategory', kind: WORKSPACE_CONTROL_KINDS.SELECT, label: 'Event category', filterType: 'simpleSelect', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 210 },
  artifactResearch: { id: 'artifactResearch', kind: WORKSPACE_CONTROL_KINDS.SELECT, label: 'Research coverage', filterType: 'simpleSelect', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 180 },
  artifactSource: { id: 'artifactSource', kind: WORKSPACE_CONTROL_KINDS.SELECT, label: 'Source', filterType: 'simpleSelect', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 180 },
  artifactRole: { id: 'artifactRole', kind: WORKSPACE_CONTROL_KINDS.SELECT, label: 'Function', filterType: 'simpleSelect', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 180 },
  artifactMaintenance: { id: 'artifactMaintenance', kind: WORKSPACE_CONTROL_KINDS.SELECT, label: 'Maintenance', filterType: 'simpleSelect', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 180 },
  artifactGuidance: { id: 'artifactGuidance', kind: WORKSPACE_CONTROL_KINDS.SELECT, label: 'Installation guidance', filterType: 'simpleSelect', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 180 },
  artifactReleaseChannel: { id: 'artifactReleaseChannel', kind: WORKSPACE_CONTROL_KINDS.SELECT, label: 'Release type', filterType: 'simpleSelect', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 155 },
  artifactReleaseActivity: { id: 'artifactReleaseActivity', kind: WORKSPACE_CONTROL_KINDS.SELECT, label: 'Version activity', filterType: 'simpleSelect', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 155 },
  artifactActivityView: { id: 'artifactActivityView', kind: WORKSPACE_CONTROL_KINDS.TOGGLE, label: 'Artifact activity', filterType: 'controlToggle', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 'auto' },
  artifactSearch: { id: 'artifactSearch', kind: WORKSPACE_CONTROL_KINDS.SELECT, label: 'Artifact', filterType: 'simpleSelect', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 240 },
  artifactPanel: { id: 'artifactPanel', kind: WORKSPACE_CONTROL_KINDS.SELECT, label: 'Artifact panel', filterType: 'simpleSelect', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 180 },

  category: {
    id: 'category',
    kind: WORKSPACE_CONTROL_KINDS.CATEGORY,
    label: 'Category',
    filterType: 'category',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 170,
  },
  ticker: {
    id: 'ticker',
    kind: WORKSPACE_CONTROL_KINDS.AUTOCOMPLETE,
    label: 'Company',
    filterType: 'ticker',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 180,
  },
  companySearch: {
    id: 'companySearch',
    kind: WORKSPACE_CONTROL_KINDS.SEARCH,
    label: 'Company Search',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 320,
  },
  project: {
    id: 'project',
    kind: WORKSPACE_CONTROL_KINDS.AUTOCOMPLETE,
    label: 'Project',
    filterType: 'project',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 260,
  },
  versionArtifact: {
    id: 'versionArtifact',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Artifact',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 220,
  },
  versionGrain: {
    id: 'versionGrain',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'Grain',
    filterType: 'controlToggle',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  versionRange: {
    id: 'versionRange',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Date Range',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 150,
  },
  versionMode: {
    id: 'versionMode',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'Measure',
    filterType: 'controlToggle',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  analysis: {
    id: 'analysis',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Analysis',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 170,
  },
  chartCompany: {
    id: 'chartCompany',
    kind: WORKSPACE_CONTROL_KINDS.AUTOCOMPLETE,
    label: 'Chart Company',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 260,
  },
  ownership: {
    id: 'ownership',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'Ownership',
    filterType: 'status',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 140,
  },
  status: {
    id: 'status',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Status',
    filterType: 'status',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 155,
  },
  aiProfile: {
    id: 'aiProfile',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'AI Profile',
    filterType: 'status',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 150,
  },
  minimum: {
    id: 'minimum',
    kind: WORKSPACE_CONTROL_KINDS.NUMBER,
    label: 'Minimum',
    filterType: 'number',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 100,
  },
  weeks: {
    id: 'weeks',
    kind: WORKSPACE_CONTROL_KINDS.SLIDER,
    label: 'Weeks',
    filterType: 'slider',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: CONTROL_SLIDER_SIZES.width,
  },
  days: {
    id: 'days',
    kind: WORKSPACE_CONTROL_KINDS.SLIDER,
    label: 'Days',
    filterType: 'slider',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: CONTROL_SLIDER_SIZES.width,
  },
  baseline: {
    id: 'baseline',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Baseline',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 156,
  },
  dateRange: {
    id: 'dateRange',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Date Range',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 156,
  },
  roles: {
    id: 'roles',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Roles',
    filterType: 'fields',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 170,
  },
  rows: {
    id: 'rows',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'Aggregate',
    filterType: 'controlToggle',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  aggregate: {
    id: 'aggregate',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'Aggregate',
    filterType: 'controlToggle',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  type: {
    id: 'type',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'Type',
    filterType: 'controlToggle',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  explore: {
    id: 'explore',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'Explore',
    filterType: 'controlToggle',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  groupBy: {
    id: 'groupBy',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Group By',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 190,
  },
  groupLevel: {
    id: 'groupLevel',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Group Level',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 145,
  },
  roleFilters: {
    id: 'roleFilters',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Role Filter',
    filterType: 'groupedMultiSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 170,
  },
  locationFilters: {
    id: 'locationFilters',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Geography Filter',
    filterType: 'groupedMultiSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 170,
  },
  productFocusFilters: {
    id: 'productFocusFilters',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Product Filter',
    filterType: 'groupedMultiSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 220,
  },
  series: {
    id: 'series',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Series',
    filterType: 'fields',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 220,
  },
  facets: {
    id: 'facets',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Filters',
    filterType: 'custom',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  shareImage: {
    id: 'shareImage',
    kind: WORKSPACE_CONTROL_KINDS.BUTTON,
    label: 'Share Image',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  view: {
    id: 'view',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'View',
    filterType: 'controlToggle',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  sort: {
    id: 'sort',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'Sort',
    filterType: 'controlToggle',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  sector: {
    id: 'sector',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'Sector',
    filterType: 'controlToggle',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  columns: {
    id: 'columns',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Columns',
    filterType: 'fields',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 250,
  },
  metric: {
    id: 'metric',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Metric',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 180,
  },
  topic: {
    id: 'topic',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Topic',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 172,
  },
  change: {
    id: 'change',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Change',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 132,
  },
  eventType: {
    id: 'eventType',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Event Type',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 132,
  },
  search: {
    id: 'search',
    kind: WORKSPACE_CONTROL_KINDS.SEARCH,
    label: 'Search',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 180,
  },
  viewMode: {
    id: 'viewMode',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'View',
    filterType: 'controlToggle',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  form: {
    id: 'form',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Form',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 112,
  },
  sourceStatus: {
    id: 'sourceStatus',
    kind: WORKSPACE_CONTROL_KINDS.SELECT,
    label: 'Source',
    filterType: 'simpleSelect',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 148,
  },
  period: {
    id: 'period',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'Period',
    filterType: 'timeFramePeriod',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 280,
  },
  sbcMode: {
    id: 'sbcMode',
    kind: WORKSPACE_CONTROL_KINDS.TOGGLE,
    label: 'SBC',
    filterType: 'controlToggle',
    context: CONTROL_CONTEXTS.OBJECT_TOOLBAR,
    defaultWidth: 'auto',
  },
  chartPeriodCount: { id: 'chartPeriodCount', kind: WORKSPACE_CONTROL_KINDS.SLIDER, label: 'Chart Periods', filterType: 'slider', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: CONTROL_SLIDER_SIZES.width },
  periodKind: { id: 'periodKind', kind: WORKSPACE_CONTROL_KINDS.TOGGLE, label: 'Period', filterType: 'controlToggle', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 'auto' },
  basis: { id: 'basis', kind: WORKSPACE_CONTROL_KINDS.TOGGLE, label: 'Basis', filterType: 'controlToggle', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 'auto' },
  calendarYear: { id: 'calendarYear', kind: WORKSPACE_CONTROL_KINDS.SELECT, label: 'Report Year', filterType: 'simpleSelect', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 126 },
  categoryRowGroupBy: { id: 'categoryRowGroupBy', kind: WORKSPACE_CONTROL_KINDS.TOGGLE, label: 'Aggregate', filterType: 'controlToggle', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 'auto' },
  reportingTimeframe: { id: 'reportingTimeframe', kind: WORKSPACE_CONTROL_KINDS.TOGGLE, label: 'Timeframe', filterType: 'controlToggle', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 'auto' },
  chartGrain: { id: 'chartGrain', kind: WORKSPACE_CONTROL_KINDS.TOGGLE, label: 'Grain', filterType: 'controlToggle', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 'auto' },
  chartCalculation: { id: 'chartCalculation', kind: WORKSPACE_CONTROL_KINDS.TOGGLE, label: 'Calculation', filterType: 'controlToggle', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 'auto' },
  chartType: { id: 'chartType', kind: WORKSPACE_CONTROL_KINDS.TOGGLE, label: 'Chart Type', filterType: 'controlToggle', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 'auto' },
  displayOptions: { id: 'displayOptions', kind: WORKSPACE_CONTROL_KINDS.TOGGLE, label: 'Display', filterType: 'controlToggle', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 'auto' },
  targetFiscalYear: { id: 'targetFiscalYear', kind: WORKSPACE_CONTROL_KINDS.SELECT, label: 'Fiscal Year', filterType: 'simpleSelect', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 132 },
  coverageChartMode: { id: 'coverageChartMode', kind: WORKSPACE_CONTROL_KINDS.TOGGLE, label: 'Coverage', filterType: 'controlToggle', context: CONTROL_CONTEXTS.OBJECT_TOOLBAR, defaultWidth: 'auto' },
};

export const WORKSPACE_PANEL_PRESETS = {
  [WORKSPACE_PANEL_KINDS.CHART]: {
    id: WORKSPACE_PANEL_KINDS.CHART,
    kind: WORKSPACE_PANEL_KINDS.CHART,
    frame: 'nivo',
    defaultVariant: 'chart',
  },
  [WORKSPACE_PANEL_KINDS.TABLE]: {
    id: WORKSPACE_PANEL_KINDS.TABLE,
    kind: WORKSPACE_PANEL_KINDS.TABLE,
    frame: 'grid',
    defaultVariant: 'table',
  },
  [WORKSPACE_PANEL_KINDS.CHART_TABLE]: {
    id: WORKSPACE_PANEL_KINDS.CHART_TABLE,
    kind: WORKSPACE_PANEL_KINDS.CHART_TABLE,
    layout: WORKSPACE_PANEL_KINDS.SPLIT,
    panels: [WORKSPACE_PANEL_KINDS.CHART, WORKSPACE_PANEL_KINDS.TABLE],
  },
  [WORKSPACE_PANEL_KINDS.SPLIT]: {
    id: WORKSPACE_PANEL_KINDS.SPLIT,
    kind: WORKSPACE_PANEL_KINDS.SPLIT,
    layout: 'twoColumn',
  },
  [WORKSPACE_PANEL_KINDS.SINGLE]: {
    id: WORKSPACE_PANEL_KINDS.SINGLE,
    kind: WORKSPACE_PANEL_KINDS.SINGLE,
    layout: 'singleColumn',
  },
  [WORKSPACE_PANEL_KINDS.KPI_STRIP]: {
    id: WORKSPACE_PANEL_KINDS.KPI_STRIP,
    kind: WORKSPACE_PANEL_KINDS.KPI_STRIP,
    layout: 'inlineMetrics',
  },
  [WORKSPACE_PANEL_KINDS.EMPTY]: {
    id: WORKSPACE_PANEL_KINDS.EMPTY,
    kind: WORKSPACE_PANEL_KINDS.EMPTY,
    layout: 'state',
  },
};

export const WORKSPACE_VISUALIZATION_PRESETS = {
  [WORKSPACE_VISUALIZATION_KINDS.TREND_LINE]: {
    id: WORKSPACE_VISUALIZATION_KINDS.TREND_LINE,
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'timeSeries',
  },
  lineChart: {
    id: 'lineChart',
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'timeSeries',
  },
  barChart: {
    id: 'barChart',
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'categorySeries',
  },
  waterfall: {
    id: 'waterfall',
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'bridgeSegments',
  },
  [WORKSPACE_VISUALIZATION_KINDS.STACKED_BAR]: {
    id: WORKSPACE_VISUALIZATION_KINDS.STACKED_BAR,
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'stackedCategorySeries',
  },
  [WORKSPACE_VISUALIZATION_KINDS.GROUPED_BAR]: {
    id: WORKSPACE_VISUALIZATION_KINDS.GROUPED_BAR,
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'groupedCategorySeries',
  },
  [WORKSPACE_VISUALIZATION_KINDS.BOXPLOT]: {
    id: WORKSPACE_VISUALIZATION_KINDS.BOXPLOT,
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'distributionSummary',
  },
  [WORKSPACE_VISUALIZATION_KINDS.SCATTER]: {
    id: WORKSPACE_VISUALIZATION_KINDS.SCATTER,
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'xyPoints',
  },
  [WORKSPACE_VISUALIZATION_KINDS.QUADRANT]: {
    id: WORKSPACE_VISUALIZATION_KINDS.QUADRANT,
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'xyPoints',
  },
  [WORKSPACE_VISUALIZATION_KINDS.HEATMAP]: {
    id: WORKSPACE_VISUALIZATION_KINDS.HEATMAP,
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'matrix',
  },
  [WORKSPACE_VISUALIZATION_KINDS.BRIDGE]: {
    id: WORKSPACE_VISUALIZATION_KINDS.BRIDGE,
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'bridgeSegments',
  },
  [WORKSPACE_VISUALIZATION_KINDS.KPI_STRIP]: {
    id: WORKSPACE_VISUALIZATION_KINDS.KPI_STRIP,
    panel: WORKSPACE_PANEL_KINDS.KPI_STRIP,
    defaultSeriesShape: 'metrics',
  },
  [WORKSPACE_VISUALIZATION_KINDS.ROLE_MIX]: {
    id: WORKSPACE_VISUALIZATION_KINDS.ROLE_MIX,
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'composition',
  },
  [WORKSPACE_VISUALIZATION_KINDS.TABLE]: {
    id: WORKSPACE_VISUALIZATION_KINDS.TABLE,
    panel: WORKSPACE_PANEL_KINDS.TABLE,
    defaultSeriesShape: 'rows',
  },
  [WORKSPACE_VISUALIZATION_KINDS.TREEMAP]: {
    id: WORKSPACE_VISUALIZATION_KINDS.TREEMAP,
    panel: WORKSPACE_PANEL_KINDS.CHART,
    defaultSeriesShape: 'hierarchy',
  },
  definitionCatalog: {
    id: 'definitionCatalog',
    panel: WORKSPACE_PANEL_KINDS.TABLE,
    defaultSeriesShape: 'rows',
  },
  definitionDetail: {
    id: 'definitionDetail',
    panel: WORKSPACE_PANEL_KINDS.SINGLE,
    defaultSeriesShape: 'detail',
  },
  changeReview: {
    id: 'changeReview',
    panel: WORKSPACE_PANEL_KINDS.SINGLE,
    defaultSeriesShape: 'textDiff',
  },
  sourceCompare: {
    id: 'sourceCompare',
    panel: WORKSPACE_PANEL_KINDS.SINGLE,
    defaultSeriesShape: 'sourceDocument',
  },
};

export const WORKSPACE_TABLE_COLUMN_PRESETS = {
  artifactTechnology: { id: 'artifactTechnology', label: 'Technology', align: 'left', minWidth: 160 },
  artifactProvider: { id: 'artifactProvider', label: 'Provider / maintainer', align: 'left', minWidth: 160 },
  artifactLatestRelease: { id: 'artifactLatestRelease', label: 'Latest artifact release', align: 'left', minWidth: 160 },
  artifactLatestChange: { id: 'artifactLatestChange', label: 'Latest known change', align: 'left', minWidth: 160 },
  artifactPublicationDate: { id: 'artifactPublicationDate', label: 'Published', align: 'left', minWidth: 160 },
  artifactReleaseScope: { id: 'artifactReleaseScope', label: 'Release scope', align: 'left', minWidth: 160 },
  artifactResearch: { id: 'artifactResearch', label: 'Research coverage', align: 'left', minWidth: 160 },
  artifactSource: { id: 'artifactSource', label: 'Source', align: 'left', minWidth: 130 },
  artifactDescription: { id: 'artifactDescription', label: 'Description', align: 'left', minWidth: 130 },
  artifactRole: { id: 'artifactRole', label: 'Function', align: 'left', minWidth: 130 },
  artifactMaintenance: { id: 'artifactMaintenance', label: 'Maintenance', align: 'left', minWidth: 130 },
  artifactGuidance: { id: 'artifactGuidance', label: 'Installation', align: 'left', minWidth: 130 },
  artifactCheckedOn: { id: 'artifactCheckedOn', label: 'Checked', align: 'left', minWidth: 130 },
  artifactVersionChange: { id: 'artifactVersionChange', label: 'Version change', align: 'left', minWidth: 125 },
  artifactReleaseResearch: { id: 'artifactReleaseResearch', label: 'Research', align: 'left', minWidth: 110 },
  artifactReleaseSignificance: { id: 'artifactReleaseSignificance', label: 'Release significance', align: 'left', minWidth: 150 },
  artifactVersion: { id: 'artifactVersion', label: 'Version', align: 'left', minWidth: 130 },
  artifactStatus: { id: 'artifactStatus', label: 'Status', align: 'left', minWidth: 130 },

  [WORKSPACE_TABLE_COLUMN_KINDS.COMPANY]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.COMPANY,
    label: 'Company',
    align: 'left',
    minWidth: 180,
    pinned: 'left',
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.TICKER]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.TICKER,
    label: 'Ticker',
    align: 'left',
    minWidth: 86,
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.METRIC_VALUE]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.METRIC_VALUE,
    label: 'Value',
    align: 'right',
    minWidth: 92,
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.MEDIAN_METRIC_VALUES]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.MEDIAN_METRIC_VALUES,
    label: 'Median Metric Values',
    align: 'right',
    minWidth: 120,
    format: 'number',
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.PERCENT]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.PERCENT,
    label: 'Percent',
    align: 'right',
    minWidth: 92,
    format: 'percent',
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.DATE]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.DATE,
    label: 'Date',
    align: 'left',
    minWidth: 110,
    format: 'date',
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.LINK]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.LINK,
    label: 'Source',
    align: 'left',
    minWidth: 120,
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.TREND_DELTA]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.TREND_DELTA,
    label: 'Change',
    align: 'right',
    minWidth: 92,
    format: 'signedNumber',
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.RANK]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.RANK,
    label: 'Rank',
    align: 'right',
    minWidth: 72,
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.CATEGORY]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.CATEGORY,
    label: 'Category',
    align: 'left',
    minWidth: 160,
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.TITLE]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.TITLE,
    label: 'Title',
    align: 'left',
    minWidth: 260,
    pinned: 'left',
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.GROUP]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.GROUP,
    label: 'Group',
    align: 'left',
    minWidth: 180,
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.REGION]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.REGION,
    label: 'Region',
    align: 'left',
    minWidth: 150,
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.SUB_REGION]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.SUB_REGION,
    label: 'Sub-region',
    align: 'left',
    minWidth: 170,
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.COMPANY_MAPPING]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.COMPANY_MAPPING,
    label: 'Company Mapping',
    align: 'left',
    minWidth: 220,
  },
  [WORKSPACE_TABLE_COLUMN_KINDS.LOCATION]: {
    id: WORKSPACE_TABLE_COLUMN_KINDS.LOCATION,
    label: 'Location',
    align: 'left',
    minWidth: 240,
  },
  filingCompany: {
    id: 'filingCompany',
    label: 'Company',
    align: 'left',
    minWidth: 190,
  },
  filingTopic: {
    id: 'filingTopic',
    label: 'Topic',
    align: 'left',
    minWidth: 145,
  },
  filingChangeKind: {
    id: 'filingChangeKind',
    label: 'Change',
    align: 'left',
    minWidth: 98,
  },
  filingChangeSummary: {
    id: 'filingChangeSummary',
    label: 'Filing Change',
    align: 'left',
    minWidth: 380,
  },
  filingDates: {
    id: 'filingDates',
    label: 'Filing Dates',
    align: 'left',
    minWidth: 148,
  },
  sourceLink: {
    id: 'sourceLink',
    label: 'Source',
    align: 'center',
    minWidth: 70,
  },
  metricLabel: {
    id: 'metricLabel',
    label: 'KPI',
    align: 'left',
    minWidth: 220,
  },
  definitionDisplayText: {
    id: 'definitionDisplayText',
    label: 'Latest Definition',
    align: 'left',
    minWidth: 430,
  },
  filingDate: {
    id: 'filingDate',
    label: 'Last Disclosed',
    align: 'left',
    minWidth: 116,
    format: 'date',
  },
  form: {
    id: 'form',
    label: 'Form',
    align: 'left',
    minWidth: 88,
  },
  sourceValidation: {
    id: 'sourceValidation',
    label: 'Source',
    align: 'center',
    minWidth: 118,
  },
  package: {
    id: 'package',
    label: 'Package',
    align: 'left',
    minWidth: 180,
  },
  project: {
    id: 'project',
    label: 'Project',
    align: 'left',
    minWidth: 180,
  },
  packages: {
    id: 'packages',
    label: 'Packages',
    align: 'right',
    minWidth: 96,
    format: 'number',
  },
  npmRolling7d: {
    id: 'npmRolling7d',
    label: 'npm 7D',
    align: 'right',
    minWidth: 104,
    format: 'number',
  },
  pypiRolling7d: {
    id: 'pypiRolling7d',
    label: 'PyPI 7D',
    align: 'right',
    minWidth: 104,
    format: 'number',
  },
  nugetRolling7d: {
    id: 'nugetRolling7d',
    label: 'NuGet 7D',
    align: 'right',
    minWidth: 104,
    format: 'number',
  },
  dockerRolling7d: {
    id: 'dockerRolling7d',
    label: 'Docker 7D',
    align: 'right',
    minWidth: 104,
    format: 'number',
  },
  terraformRolling7d: {
    id: 'terraformRolling7d',
    label: 'Terraform 7D',
    align: 'right',
    minWidth: 116,
    format: 'number',
  },
  entity: {
    id: 'entity',
    label: 'Entity',
    align: 'left',
    minWidth: 180,
  },
  current: {
    id: 'current',
    label: 'Current',
    align: 'right',
    minWidth: 92,
    format: 'number',
  },
  delta1d: {
    id: 'delta1d',
    label: '1D',
    align: 'right',
    minWidth: 82,
    format: 'signedNumber',
  },
  delta1dPct: {
    id: 'delta1dPct',
    label: '1D %',
    align: 'right',
    minWidth: 82,
    format: 'percent',
  },
  delta7d: {
    id: 'delta7d',
    label: '7D',
    align: 'right',
    minWidth: 82,
    format: 'signedNumber',
  },
  delta7dPct: {
    id: 'delta7dPct',
    label: '7D %',
    align: 'right',
    minWidth: 82,
    format: 'percent',
  },
  delta14d: {
    id: 'delta14d',
    label: '14D',
    align: 'right',
    minWidth: 82,
    format: 'signedNumber',
  },
  delta14dPct: {
    id: 'delta14dPct',
    label: '14D %',
    align: 'right',
    minWidth: 82,
    format: 'percent',
  },
  delta28d: {
    id: 'delta28d',
    label: '28D',
    align: 'right',
    minWidth: 82,
    format: 'signedNumber',
  },
  delta28dPct: {
    id: 'delta28dPct',
    label: '28D %',
    align: 'right',
    minWidth: 82,
    format: 'percent',
  },
  compositeMovePct: {
    id: 'compositeMovePct',
    label: 'Composite Move',
    align: 'right',
    minWidth: 112,
    format: 'percent',
  },
  companyCount: {
    id: 'companyCount',
    label: 'Companies',
    align: 'right',
    minWidth: 96,
    format: 'number',
  },
  median: {
    id: 'median',
    label: 'Median',
    align: 'right',
    minWidth: 96,
    format: 'number',
  },
  p25: {
    id: 'p25',
    label: 'P25',
    align: 'right',
    minWidth: 88,
    format: 'number',
  },
  p75: {
    id: 'p75',
    label: 'P75',
    align: 'right',
    minWidth: 88,
    format: 'number',
  },
  min: {
    id: 'min',
    label: 'Min',
    align: 'right',
    minWidth: 88,
    format: 'number',
  },
  max: {
    id: 'max',
    label: 'Max',
    align: 'right',
    minWidth: 88,
    format: 'number',
  },
  positiveBreadth: {
    id: 'positiveBreadth',
    label: 'Breadth',
    align: 'right',
    minWidth: 96,
    format: 'percent',
  },
  mean: {
    id: 'mean',
    label: 'Mean',
    align: 'right',
    minWidth: 96,
    format: 'number',
  },
  period: {
    id: 'period',
    label: 'Period',
    align: 'left',
    minWidth: 104,
  },
  revenue: {
    id: 'revenue',
    label: 'Revenue',
    align: 'right',
    minWidth: 110,
    format: 'currency',
  },
  growth: {
    id: 'growth',
    label: 'Growth',
    align: 'right',
    minWidth: 96,
    format: 'percent',
  },
  margin: {
    id: 'margin',
    label: 'Margin',
    align: 'right',
    minWidth: 96,
    format: 'percent',
  },
  acceleration: {
    id: 'acceleration',
    label: 'Acceleration',
    align: 'right',
    minWidth: 110,
    format: 'percent',
  },
  grossMargin: {
    id: 'grossMargin',
    label: 'Gross Margin',
    align: 'right',
    minWidth: 120,
    format: 'percent',
  },
  operatingMargin: {
    id: 'operatingMargin',
    label: 'Operating Margin',
    align: 'right',
    minWidth: 130,
    format: 'percent',
  },
  freeCashFlowMargin: {
    id: 'freeCashFlowMargin',
    label: 'FCF Margin',
    align: 'right',
    minWidth: 120,
    format: 'percent',
  },
  metric: {
    id: 'metric',
    label: 'Metric',
    align: 'left',
    minWidth: 160,
  },
  actual: {
    id: 'actual',
    label: 'Actual',
    align: 'right',
    minWidth: 104,
    format: 'number',
  },
  estimate: {
    id: 'estimate',
    label: 'Estimate',
    align: 'right',
    minWidth: 104,
    format: 'number',
  },
  metricName: { id: 'metricName', label: 'Metric', align: 'left', minWidth: 160 },
  guidance: { id: 'guidance', label: 'Guidance', align: 'right', minWidth: 104, format: 'number' },
  beatMiss: { id: 'beatMiss', label: 'Beat / Miss', align: 'right', minWidth: 104, format: 'percent' },
  lastQuarterMedianBeatPct: { id: 'lastQuarterMedianBeatPct', label: 'Last Quarter', align: 'right', minWidth: 110, format: 'percent' },
  priorQuarterMedianBeatPct: { id: 'priorQuarterMedianBeatPct', label: 'Prior Quarter', align: 'right', minWidth: 110, format: 'percent' },
  ttmMedianBeatPct: { id: 'ttmMedianBeatPct', label: 'TTM', align: 'right', minWidth: 92, format: 'percent' },
  ptmMedianBeatPct: { id: 'ptmMedianBeatPct', label: 'Prior TTM', align: 'right', minWidth: 100, format: 'percent' },
  lastFiveYearsMedianBeatPct: { id: 'lastFiveYearsMedianBeatPct', label: 'Five Year', align: 'right', minWidth: 110, format: 'percent' },
  q1CurrentFyMedianRevisionPct: { id: 'q1CurrentFyMedianRevisionPct', label: 'Current FY', align: 'right', minWidth: 110, format: 'percent' },
  q1PriorFyMedianRevisionPct: { id: 'q1PriorFyMedianRevisionPct', label: 'Prior FY', align: 'right', minWidth: 110, format: 'percent' },
  q1TwoYearsPriorMedianRevisionPct: { id: 'q1TwoYearsPriorMedianRevisionPct', label: 'Two Years Prior', align: 'right', minWidth: 130, format: 'percent' },
  q1LastFiveYearsMedianRevisionPct: { id: 'q1LastFiveYearsMedianRevisionPct', label: 'Five Year', align: 'right', minWidth: 110, format: 'percent' },
  targetFiscalYear: { id: 'targetFiscalYear', label: 'Fiscal Year', align: 'left', minWidth: 104 },
  initialGuide: { id: 'initialGuide', label: 'Initial Guide', align: 'right', minWidth: 110, format: 'number' },
  q1Revision: { id: 'q1Revision', label: 'Q1 Revision', align: 'right', minWidth: 104, format: 'percent' },
  q2Revision: { id: 'q2Revision', label: 'Q2 Revision', align: 'right', minWidth: 104, format: 'percent' },
  q3Revision: { id: 'q3Revision', label: 'Q3 Revision', align: 'right', minWidth: 104, format: 'percent' },
  latestGuide: { id: 'latestGuide', label: 'Latest Guide', align: 'right', minWidth: 110, format: 'number' },
  currentRpoCoverage: { id: 'currentRpoCoverage', label: 'cRPO Coverage', align: 'right', minWidth: 120, format: 'percent' },
  deferredRevenueCoverage: { id: 'deferredRevenueCoverage', label: 'Deferred Revenue Coverage', align: 'right', minWidth: 160, format: 'percent' },
  arrCoverage: { id: 'arrCoverage', label: 'ARR Coverage', align: 'right', minWidth: 110, format: 'percent' },
  ttmBookings: { id: 'ttmBookings', label: 'TTM Bookings', align: 'right', minWidth: 120, format: 'number' },
  ttmBillings: { id: 'ttmBillings', label: 'TTM Billings', align: 'right', minWidth: 120, format: 'number' },
};

const REGISTRIES = {
  controls: WORKSPACE_CONTROL_PRESETS,
  panels: WORKSPACE_PANEL_PRESETS,
  visualizations: WORKSPACE_VISUALIZATION_PRESETS,
  tableColumns: WORKSPACE_TABLE_COLUMN_PRESETS,
};

export const getWorkspaceRegistry = (registryName) => REGISTRIES[registryName] || {};

export const getWorkspaceRegistryEntry = (registryName, id) => {
  if (!id) return null;
  return getWorkspaceRegistry(registryName)[id] || null;
};

export const hasWorkspaceRegistryEntry = (registryName, id) => (
  Boolean(getWorkspaceRegistryEntry(registryName, id))
);

export const listWorkspaceRegistryIds = (registryName) => (
  Object.keys(getWorkspaceRegistry(registryName))
);
